import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import SearchPage from '../search/SearchPage'
import ShowProducentarendetyp from "../showProducentarendetyp/ShowProducentarendetyp";
import './App.css';
import ShowProducent from "../showProducent/ShowProducent";
import IntroPage from "../intro/IntroPage";

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/search" element={<SearchPage />} />
                <Route path="/producentarendetyp/:id" element={<ShowProducentarendetyp />} />
                <Route path="/producent/:id" element={<ShowProducent />} />
                <Route path="/" element={<IntroPage />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;
